// src/components/ParametreClient.tsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box, Button, TextField, Typography, CircularProgress, Alert,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
  MenuItem,
  Autocomplete,
  TablePagination
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
//import { BilletageDevise, DateSys } from '../interfaces/GlobalInterface';
import { apiEndpoints } from '../../../config';
import { date } from 'yup';
//import { Devise } from '../dataTypes/GlobalDataType';
import { Lib } from '../../../dataTypes/GlobalDataType';
import { fetchDataTable,formatDate,getField,getFirstPart, getLastPart } from '../../../utilitaires/globalFunction';
import { Controller, useForm } from 'react-hook-form';
//import Utilisateur from '../Models/Utilisateur';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';

//import Data from '../../../Types/Data';

import { Crypter } from '../../../Functions/Security/Crypter';
import Hash from '../../../Functions/Security/Hash';
import Agence from '../../../Models/Agence';
import { lib } from 'crypto-js';
import Data from "../../../Data/Data.json"



//import { Billetage } from '../types/BilletageCaisse'; // Assurez-vous du chemin correct

const API_URL = Data.ApiUrl.BilletageCaisse;
interface RubriqProps {
  Rubri: string;
  
}
 

const ParametreClient: React.FC<RubriqProps> = ({
  Rubri})=> {

  const { register,  reset, setValue, control, formState: { errors } } = useForm<Lib>();
  
  const [billetages, setBilletages] = useState<Lib[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentBilletage, setCurrentBilletage] = useState<Lib | null>(null);
  const [dialogError, setDialogError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
 const [datJour, setDatJour] = useState<Date>(new Date());
 const [dataDevise, setDataDevise] = useState<Lib[]>([]);
 const [searchTerm, setSearchTerm] = useState('');
 const [page, setPage] = useState(0);
 const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici

 
  //const { user, logout } = useAuth();
const auth = useAuthUser()
   const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  // USER TOKEN
  const authHeader = useAuthHeader()

  
  // --- Fonction pour charger toutes les dénominations (READ - GET ALL) ---
  const fetchBilletages = async () => {
    setLoading(true);
    setError(null);

                   
    try {
 var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${apiEndpoints.lib}/ReadLib`,
            headers: {
            'Authorization': authHeader(),
            'Content-Type': 'application/json',
            CypherLib:Rubri
                 },
                                      
                    };
          axios.request(config)
               .then(function (response) {
                 if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                  console.log(res.Result.Table)
                    if (res.StatutCode == 200) {
                        setBilletages(res.Result.Table)
                                              
                                          }
              
                                      }
                                      //console.log(JSON.stringify(response.data));
                                  })


    
    } catch (err) {
      console.error("Erreur de chargement:", err);
      setError("Impossible de charger les données de bielletage.");
    } finally {
      setLoading(false);
    }
  };

   

  useEffect(() => {
    fetchBilletages(); // Charger les données au montage du composant
   
   // loadDataDevise(); // Charger les données de devise
  }, [Rubri]);

 
  // --- Gérer l'ouverture du dialogue pour ajouter/modifier ---
  const handleOpenDialog = (billetageToEdit: Lib | null = null) => {
    if (billetageToEdit) {
      setCurrentBilletage({ ...billetageToEdit }); // Copie pour l'édition
    } else {
      // Initialiser un nouvel objet avec des valeurs par défaut
      setCurrentBilletage({
        NLIGNE: 0, // valeur par défaut pour nligne
        CODLIB: '',
         LIBELL: '', // valeur par défaut pour Libelle
        RUBRIQ: Rubri,
        UTILIS: '',
        DATCRE: "01/01/2025",
        
       
        // Ajoutez ici d'autres propriétés requises par Lib si nécessaire
      });
    }
    setOpenDialog(true);
    setDialogError(null); // Réinitialiser les erreurs du dialogue
  };
async function loadDataDevise() {
        console.log(apiEndpoints.lib)
        const data = await fetchDataTable(apiEndpoints.lib);
        setDataDevise(data); // ou console.log(data)
      }
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentBilletage(null);
    setDialogError(null);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setCurrentBilletage(prev => {
      if (!prev) return null;
      // Convertir en nombre si c'est un champ numérique
      // if (name === 'quantite' || name === 'qteAdd') {
      //   return { ...prev, [name]: parseFloat(value) || 0 };
      // }
      return { ...prev, [name]: value };
    });
  };

  // 📄 Filtrage des données en fonction du terme de recherche
  const filteredBilletages = billetages.filter((item) =>
    Object.values(item).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  // 📄 Pagination après filtrage
  const paginatedBilletages = filteredBilletages.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // 🔁 Gestion du changement de page
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // 🔁 Gestion du changement de nombre de lignes
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Revenir à la première page après changement
  };
  // --- Gérer la soumission du formulaire (CREATE / UPDATE) ---
  const handleSubmit = async () => {
    if (!currentBilletage) return;

    setSubmitting(true);
    setDialogError(null);

    // Validation des champs clés (doivent être non vides)
    // if (!currentBilletage.CodLib || !currentBilletage.Libell || !currentBilletage.CodVal || !currentBilletage.Valeur) {
    //   setDialogError("Les champs Code Devise, Num Caisse, Code Bureau, Code Valeur et Code Utilisateur sont obligatoires.");
    //   setSubmitting(false);
    //   return;
    // }

    try {
      // Déterminer si c'est une création ou une mise à jour
      const isNew = !billetages.some(b =>
        b.CODLIB === currentBilletage.CODLIB 
        //b.LIBELL === currentBilletage.LIBELL &&
       // b.RUBRIQ === currentBilletage.RUBRIQ 
        // b.Valeur === currentBilletage.Valeur
      );

      currentBilletage.CODLIB= currentBilletage?.CODLIB || "";//getFirstPart(currentBilletage?.CODLIB || "", "-")
      setDatJour( await getField("datgen", "codage", "datjour", "codage", user?.codage|| "", user?.codage || ""))  
      //getField("DateSys","CodBur","DatJour","codBur","","")
      //const specificDateSysItem = dateSys.find(item => item.CodBur === user?.CodBur);
      const dates = datJour ? datJour : new Date().toISOString(); // Utiliser la date du système ou la date actuelle
      currentBilletage.DATCRE =   formatDate(datJour) ; // Assurez-vous que DATCRE est au format attendu
      currentBilletage.UTILIS = user?.coduti

      if (isNew) {
        console.log(currentBilletage)
        
         let data = Crypter.encrypt(JSON.stringify(currentBilletage));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: `${apiEndpoints.lib}/CreateLib`,
                        headers: {
                            CypherLib: data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
         
                axios.request(config)
               .then(function (response) {
                 if (response.data) {
                 // const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                 // console.log(res.StatutCode)
                   // if (res.StatutCode == 200) {
                      //  setBilletages(res.Result.Table)
                       alert('Nouveau code enregistré avec succès!');                         
                                  //        }
              
                                      }
                                      //console.log(JSON.stringify(response.data));
                                  })

      
      } else {
        // Pour PUT, l'URL doit inclure toutes les clés primaires
        // const url = `${apiEndpoints.lib}/${currentBilletage.LIBELL}/${currentBilletage.LIBELL}/${currentBilletage.RUBRIQ}/${currentBilletage.UTILIS}`;
        // await axios.put(url, currentBilletage);
          console.log(currentBilletage)
        
         let data = Crypter.encrypt(JSON.stringify(currentBilletage));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: `${apiEndpoints.lib}/UpdateLib`,
                        headers: {
                            CypherLib: data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };
         
                axios.request(config)
               .then(function (response) {
                 if (response.data) {
                  // const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                  // console.log(res.StatutCode)
                  //  if (res.StatutCode == 200) {
                       // setBilletages(res.Result.Table)
                       alert('Code mis à  jour avec succès!');                         
                                      //    }
              
                                      }
                                      //console.log(JSON.stringify(response.data));
                                  })

        
      }
      handleCloseDialog();
      fetchBilletages(); // Recharger les données après ajout/édition
    } catch (err) {
      console.error("Erreur de soumission:", err);
      if (axios.isAxiosError(err) && err.response) {
        setDialogError(`Erreur: ${err.response.data || err.message}`);
      } else {
        setDialogError("Une erreur inattendue est survenue lors de l'enregistrement.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  // --- Gérer la suppression (DELETE) ---
  const handleDelete = async (billetageToDelete: Lib) => {
    const confirmDelete = window.confirm(
      `Êtes-vous sûr de vouloir supprimer l'entrée pour : ${billetageToDelete.CODLIB}, : ${billetageToDelete.LIBELL},?`
    );

    if (confirmDelete) {
      setLoading(true); // Indiquer un chargement global pour la table
      setError(null);
      try {
        console.log(billetageToDelete)
        
         let data = Crypter.encrypt(JSON.stringify(billetageToDelete));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: `${apiEndpoints.lib}/DeleteLib`,
                        headers: {
                            CypherLib: data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        
                        data: data
                    };
         
                axios.request(config)
               .then(function (response) {
                 if (response.data) {
                 // const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                 // console.log(res.StatutCode)
                    
                       alert('Suppession effectué avec succès!');                         
                                        
              
                                      }
                                      //console.log(JSON.stringify(response.data));
                                  })

        //const url = `${apiEndpoints.lib}/${billetageToDelete.LIBELL}/${billetageToDelete.LIBELL}/${billetageToDelete.RUBRIQ}/${billetageToDelete.UTILIS}`;
        //await axios.delete(url);
        //alert('Entrée de bielletage supprimée avec succès!');
        fetchBilletages(); // Recharger les données après suppression
      } catch (err) {
        console.error("Erreur de suppression:", err);
        if (axios.isAxiosError(err) && err.response) {
          setError(`Erreur: ${err.response.data || err.message}`);
        } else {
          setError("Impossible de supprimer l'entrée de bielletage.");
        }
      } finally {
        setLoading(false);
      }
    }
  };

  if (loading && billetages.length === 0) {
    return (
      <Box  mb={2} fontStyle="inherit" className='border' sx={{p:1}}>
        <CircularProgress />
        <Typography variant="h6" sx={{ ml: 2 }}>Chargement des données...</Typography>
      </Box>
    );
  }

  return (
    <Box  mb={3} mt={3} fontStyle="inherit" className='border' sx={{p:1}}>
      <Typography variant="h5" gutterBottom>
        Gestion paramètres profile  {Rubri.toLocaleLowerCase()}
      </Typography>

      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => handleOpenDialog()}
        sx={{ mb: 2 }}
      >
        Ajouter 
      </Button>

    {/* Zone de recherche */}
      <Box sx={{ mb: 2 }}>
        <TextField
          label="Recherche"
          variant="outlined"
          fullWidth
          value={searchTerm}
           onChange={(e) => {
            setSearchTerm(e.target.value);
            setPage(0); // Remettre à la page 0 après recherche
          }}
          size="small"
          
        />
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <TableContainer component={Paper} elevation={3} sx={{
          // --- Styles pour les ascenseurs ---
          maxHeight: 400, // Hauteur maximale pour l'ascenseur vertical (ajustez selon besoin)
          overflowY: 'auto', // Active l'ascenseur vertical si le contenu dépasse
          overflowX: 'auto', // Active l'ascenseur horizontal si le contenu dépasse
          width: '100%', // S'assure que le conteneur prend toute la largeur disponible
          minWidth: 1300, // Optionnel: Si vous voulez une largeur minimale pour le conteneur
        }}>
        <Table stickyHeader >
          <TableHead  >
            <TableRow sx={{  height: 32, minHeight: 32, size:"small" }}>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41",  fontWeight:"bold"}}>Code </TableCell>
             
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41",  fontWeight:"bold"}}>Libellé</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold" }}>Rubrique</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold" }}>Crée le</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold" }}>Crée par</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedBilletages.length === 0 ? (
              <TableRow>
                <TableCell colSpan={10} align="center">Aucune entrée de code trouvée.</TableCell>
              </TableRow>
            ) : (
              paginatedBilletages.map((item,index) => (
                <TableRow   key={`${item.CODLIB}-${item.LIBELL}-${item.RUBRIQ}`}  sx={{
                                                     cursor: 'pointer',
                                                      backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                                     '&:hover': {
                                                      // backgroundColor: '#e0f7fa', // Couleur au survol
                                                     // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                                                      //color: '#fff', // Texte blanc sur fond sombre
                                                      background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                                                        },
                                                             }}>
                   {/* Clé unique pour React */}
                  <TableCell sx={{ py: 0.5 }}>{item.CODLIB}</TableCell>
                  <TableCell sx={{ py: 0.5 }}>{item.LIBELL}</TableCell>
                  <TableCell sx={{ py: 0.5 }}>{item.RUBRIQ}</TableCell>
                  <TableCell sx={{ py: 0.5 }}> {item.DATCRE ? new Date(item.DATCRE).toLocaleDateString() : 'N/A'}</TableCell>
                  <TableCell sx={{ py: 0.5 }}>{item.UTILIS ?? 'N/A'}</TableCell>
                 
                  <TableCell sx={{ py: 0.5 }}>
                    <IconButton color="primary" onClick={() => handleOpenDialog(item)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="error" onClick={() => handleDelete(item)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

    {/* Pagination */}
      <TablePagination
        component="div"
        count={filteredBilletages.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
        labelRowsPerPage="Lignes par page"
      />
      {/* --- Dialogue pour Ajouter/Modifier --- */}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>{currentBilletage?.CODLIB ? "Modifier un code" : "Ajouter nouveau code "}</DialogTitle>
        <DialogContent dividers>
          {dialogError && <Alert severity="error" sx={{ mb: 2 }}>{dialogError}</Alert>}
          {currentBilletage && (
            <Box component="form" sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
              {/* Champs de la clé primaire (désactivés en mode édition) */}

              
   <TextField
    label="Code"
  size="small"
  required
  {...register("CODLIB", { required: "Le code est requise" })}
  value={currentBilletage.CODLIB}
  //value={watch("LIBELL")} // ou getValues("LIBELL") selon usage
  onChange={(event) => {
    const newValue = event.target.value;

    // 1. Mettre à jour le champ dans React Hook Form
    setValue("CODLIB", newValue); // (si tu veux forcer le changement, sinon `register` suffit)

    // 2. Mettre à jour l’état local
    setCurrentBilletage(prev => {
      if (!prev) return null;
      return { ...prev, CODLIB: newValue };
    });

    // 3. Appeler handleInputChange
    if (typeof handleInputChange === "function") {
      handleInputChange(event);
    }
  }}
  onBlur={(event) => {
    if (typeof handleInputChange === "function") {
      handleInputChange(event);
    }
  }}
  onClick={loadDataDevise}
  error={!!errors?.CODLIB}
  helperText={errors?.CODLIB?.message}
  sx={{
    borderRadius: "10px",
    "& .MuiOutlinedInput-root": { borderRadius: "10px" }
    }}
   />         
              <TextField
                label="libelle"
               // name="libell"
                 size="small"
                 {...register("LIBELL", { required: "Le libellé est requise" })}
                 value={currentBilletage.LIBELL}
                 onChange={handleInputChange}
                 required
               /> 

             
       
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          
          <Button onClick={handleSubmit} startIcon={<SaveIcon />} variant="contained" disabled={submitting}>
            {submitting ? <CircularProgress size={24} /> : "Enregistrer"}
          </Button>
          <Button onClick={handleCloseDialog} startIcon={<CancelIcon />} variant="contained">Annuler</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ParametreClient;